/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SecureTransferRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {SecureTransferResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const secureTransfer = (request: SecureTransferRequest, options?: CashRequestOptions) => post<SecureTransferRequest, SecureTransferResponse>("/2.0/cash/secure-transfer", request, {...options, rejectOnError: true })